import { CustomerModel } from '.';
import { translate } from '../helpers/frontend';

/*
  gender :
    0 = ไม่ระบุ
    1 = ชาย
    2 = หญิง
    3 = อื่นๆ
*/

export class CustomerContactModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.customer = new CustomerModel(data.customer || {});
    
    this.prefix = data.prefix? unescape(data.prefix): null;
    this.firstname = data.firstname? unescape(data.firstname): null;
    this.lastname = data.lastname? unescape(data.lastname): null;

    this.emails = data.emails;
    this.telephones = data.telephones;
    
    this.nickname = data.nickname || null;
    this.birthDate = data.birthDate || null;
    this.gender = data.gender? Number(data.gender): 0;
    
    this.note = data.note? unescape(data.note): null;
    
    this.isPrimary = data.isPrimary? Number(data.isPrimary): 0;
  }

  isValid(){ return this._id? true: false; }
  
  displayName() {
    if(this.firstname || this.lastname)
      return `${this.prefix || ''} ${this.firstname || ''} ${this.lastname || ''}`.trim();
    return '';
  }
  displayPrimary(langObj={}) {
    if(!this.isValid()) return (<></>);
    if(this.isPrimary === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
    return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
  }
}